<template>
	<div>
		<el-table
			v-bind:data="orderedSchedule"
			:show-header="false"
			row-key="id"
			@row-click="expandRow"
			:expand-row-keys="expand"
			empty-text="No events scheduled"
			style="width: 100%">

			<!-- Expandable message history list -->
			<el-table-column type="expand">
				<template slot-scope="scope">
					<!-- Show a button to print facesheets, copy to chart -->
				</template>
			</el-table-column>

			<el-table-column prop="time" width="80">
				<template slot-scope="scope">
					{{ formatDate(scope.row.time) }}
				</template>
			</el-table-column>

			<el-table-column prop="title">
				<template slot-scope="scope">
					<strong style="display:block;margin-bottom:3px;">
						{{ getEventName(scope.row.event) || scope.row.event_name }} with
						{{ getPatientName(scope.row.auth) }}
					</strong>
					<!-- <MessageStatus :patient="patient" :schedule="scope.row">
					</MessageStatus> -->
				</template>
			</el-table-column>

			<!-- <el-table-column prop="title">
				<template slot-scope="scope">
					<MessageStatus :patient="patient" :schedule="scope.row">
					</MessageStatus>
				</template>
			</el-table-column> -->

			<el-table-column fixed="right" width="130">
				<template slot-scope="scope">
					<el-button type="text" size="small"
						v-bind:disabled="scheduling"
						@click="editSchedule(scope.row, $event)">
						EDIT
					</el-button>
					&nbsp;&nbsp;&nbsp;&middot;
					<el-button type="text" size="small"
						@click="removeSchedule(scope.row, $event)">
						<span style="color:red">REMOVE</span>
					</el-button>
				</template>
			</el-table-column>
		</el-table>

		<el-dialog
			:title="editTitle"
			:visible.sync="showEdit"
			:append-to-body="true"
			width="400px">
			<div style="margin-top:-20px;text-align:center;">
			    <el-date-picker
					ref="edit"
					v-model="editTime"
					type="date"
					format="MMM d, yyyy"
					range-separator="/"
					placeholder="Select new date">
			    </el-date-picker>
				&nbsp;&nbsp;
				<el-button @click="sendEditSchedule" type="primary">Edit Event</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import formatDate from '@/module/util/format-date'
import formatDateTime from '@/module/util/format-date-time'
import MessageTimeline from './message/Timeline'
import MessageStatus from './message/Status'
const CELL_STYLE = {
	date: {
		color: '#5f5f5f',
		fontWeight: '700'
	},
	title: {
		fontWeight: '500'
	}
}
export default {
	name: 'population-schedule-card-table',
	props: {
		schedule: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			edit: null,
			editTime: null,
			showEdit: false,
			expand: [ ],
			scheduling: false
		}
	},
	methods: {
		...mapActions('provider', [
			'updatePatientSchedule',
			'removePatientSchedule'
		]),
		formatDate,
		formatDateTime,
		expandRow(row, a, b) {
			if (this.expand[0] == row.id)
				this.expand = []
			else
				this.expand = [ row.id ]
		},
		editSchedule(schedule, e) {
			e.stopPropagation()
			this.editTime = schedule.time
			this.edit = schedule
			this.showEdit = true
			setTimeout(() => {
				this.$refs.edit.focus()
			}, 300)
		},
		sendEditSchedule() {
			if (this.editTime == null || this.scheduling)
				return
			var time = new Date(this.editTime).getTime()
			time -= new Date().getTimezoneOffset() * 60000
			this.updatePatientSchedule({
				patient: this.patient.id,
				id: this.edit.id,
				time
			})
			.then(() => {
				this.edit = null
				this.editTime = null
				this.showEdit = false
			})
		},
		removeSchedule(schedule, e) {
			e.stopPropagation()
			this.$confirm('This will permanently delete <strong>' +
				this.getEventName(schedule.event) + '</strong> on <strong>' +
				this.formatDate(schedule.time, true) + '</strong> from ' +
				this.patient.name + '\'s appointment schedule.',
				'Are you sure?', {
					confirmButtonText: 'Delete event',
					cancelButtonText: 'Cancel',
					confirmButtonClass: 'el-button--danger',
					dangerouslyUseHTMLString: true
		        })
			.then(() => {
				return this.removePatientSchedule({
					patient: this.patient.id,
					id: schedule.id
				})
	        })
			.catch((error) => {
				console.log(error)
				// canceled
	        });
		}
	},
	computed: {
		...mapGetters('content', [
			'getContent'
		]),
		...mapGetters('provider', [
			'getPatient',
			'getPatientSchedule',
			'getPatientLoadingState',
			'getPatientSchedulingState'
		]),
		scheduleByDay() {
			// TODO: group schedule by day
		},
		getPatientName() {
			return (id) => {
				let patient = this.getPatient(id)
				if (patient)
					return patient.name
			}
		},
		getEventName() {
			return (id) => {
				let event = this.getContent('event', id)
				if (event)
					return event.name
			}
		},
		orderedSchedule() {
			if (this.schedule)
				return this.schedule.slice().sort((a, b) => (a.time - b.time))
		},
		editTitle() {
			if (this.edit)
				return 'Edit date of ' + this.getEventName(this.edit.event)
		}
	},
	components: {
		MessageTimeline,
		MessageStatus
	}
}
</script>